import { useState } from "react";
import { CrearEntidadForm, Input } from "@/components/ui";
import { toastError } from "@/lib/toast";
import { useCrearEquivalencia } from "../hooks/use-equivalencia-mutations";

/**
 * Formulario de creación de equivalencia · clave SAT + unidad SAP obligatorias,
 * descripción opcional. La clave SAT es inmutable después de crear (identifica
 * el par); para cambiarla se elimina y se recrea.
 */
export function EquivalenciaCrearForm({ onSalir }: { onSalir: () => void }) {
  const [claveUnidadSat, setClaveUnidadSat] = useState("");
  const [unidadSap, setUnidadSap] = useState("");
  const [descripcion, setDescripcion] = useState("");

  const crear = useCrearEquivalencia({ onCreado: onSalir });

  const submit = () => {
    if (!claveUnidadSat.trim() || !unidadSap.trim()) {
      toastError({ title: "Datos incompletos", message: "Clave SAT y unidad SAP obligatorias." });
      return;
    }
    crear.mutate({ claveUnidadSat: claveUnidadSat.trim(), unidadSap: unidadSap.trim(), descripcion: descripcion.trim() || null });
  };

  return (
    <CrearEntidadForm
      titulo="Nueva equivalencia"
      descripcion="Relaciona la clave de unidad del SAT (ej. H87) con la unidad de SAP (ej. PZA)."
      cols={3}
      onCancelar={onSalir}
      onCrear={submit}
      creando={crear.isPending}
    >
      <Input label="Clave unidad SAT" placeholder="H87" value={claveUnidadSat} onChange={(e) => setClaveUnidadSat(e.currentTarget.value.toUpperCase())} required />
      <Input label="Unidad SAP" placeholder="PZA" value={unidadSap} onChange={(e) => setUnidadSap(e.currentTarget.value.toUpperCase())} required />
      <Input label="Descripción" placeholder="Pieza" value={descripcion} onChange={(e) => setDescripcion(e.currentTarget.value)} />
    </CrearEntidadForm>
  );
}
